import MDBox from "components/MDBox";
import axios from "axios";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState, useEffect } from "react";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";

import CloseIcon from '@mui/icons-material/Close';
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import IconButton from '@mui/material/IconButton';

import Completion from "./Completion";
import '../user_service_maintenace_mgmt/Somecss.css';

function PopAddBasic(props) {
    const [isDialogOpen, setIsDialogOpen] = useState(props.isDialog);
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;
    const [dialogMessage, setDialogMessage] = useState("Created");

    const { enqueueSnackbar } = useSnackbar();
    const [values, setValues] = useState(props.value);
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (value.length > 300) return;

        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const reset = (event) => {
        event.preventDefault();
        values.question = "";
        values.answer = "";
        values.category = "";
        setValues(props.value);
    }
    const handleClose = () => {
        onClose(false);
    };
    const pop = () => {
        if (!values.question || !values.answer || !values.category) {
            return enqueueSnackbar(
                "Please Fill All The Details !!!",
                { variant: "error" }
            );
        }

        if (
            values.question.length > 300 ||
            values.answer.length > 300 ||
            values.category.length > 300
        ) {
            return enqueueSnackbar(
                "Each field must be within 300 characters",
                { variant: "error" }
            );
        }

        setIsBackdrop(false);
        createUser();
    };

    const createUser = () => {
        onClose(false);
        const payload = {
            "question": values.question,
            "answer": values.answer,
            "category": values.category
        };
        const isUpdate = values._id ? true : false;
        const method = isUpdate ? "put" : "post";
        const url = isUpdate
            ? `${process.env.REACT_APP_BASEURL}faq/${values._id}`
            : `${process.env.REACT_APP_BASEURL}faq`;
        if (isUpdate) {
            setDialogMessage("Updated")
        }
        axios({
            method: method,
            url: url,
            data: payload,
            withCredentials: true,

        })
            .then((response) => {
                if (response.data.success === true) {
                    setIsDisabled(!isDisabled);
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error' });
                }
            })
            .catch((error) => {
                enqueueSnackbar(error.response?.data?.message, { variant: 'error' });
            });
    };
    useEffect(() => {
        setIsDialogOpen(props.isDialog);
    }, [props.isDialog]);
    useEffect(() => {
        setValues(props.value);
    }, [props.value]);
    return (
        <>
            <Completion
                isDialog={isDisabled}
                onClose={setIsDisabled}
                message={dialogMessage}

            />
            <MDBackdrop isBackdrop={isBackdrop} />

            <Dialog open={isDialogOpen} onClose={handleClose} fullWidth maxWidth="md" >
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                    {values._id ? "Update" : "Create"} Faq Information
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}>

                        </MDBox>

                        <MDBox p={1} component="form" role="form">
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Question"
                                    value={values.question}
                                    name="question"
                                    fullWidth
                                    inputProps={{ maxLength: 300 }}
                                    onChange={handleChange}
                                />
                                <MDBox display="flex" justifyContent="flex-end" px={1}>
                                    <small>{values.question?.length || 0}/300</small>
                                </MDBox>

                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Answer"
                                    value={values.answer}
                                    name="answer"
                                    fullWidth={true}
                                    inputProps={{ maxLength: 300 }}
                                    onChange={handleChange}
                                />
                                <MDBox display="flex" justifyContent="flex-end" px={1}>
                                    <small>{values.answer?.length || 0}/300</small>
                                </MDBox>

                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Category"
                                    value={values.category}
                                    name="category"
                                    fullWidth={true}
                                    inputProps={{ maxLength: 100 }}
                                    onChange={handleChange}
                                />
                                <MDBox display="flex" justifyContent="flex-end" px={1}>
                                    <small>{values.category?.length || 0}/100</small>
                                </MDBox>

                            </MDBox>

                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>
                    <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
                        Reset
                    </MDButton>
                    <MDButton variant="gradient" color={sidenavColor}

                        onClick={pop}
                    >
                        {values._id ? "Update" : "Create"}
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddBasic;